var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendsprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "72.000000pt",
    height: "72.000000pt",
    viewBox: "0 0 72.000000 72.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,72.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239 481 c-34 -34 -37 -69 -12 -112 22 -36 46 -43 127 -37 50 4 68 2 87 -12 l23 -18 -24 -21 c-28 -22 -41 -26 -56 -12 -5 5 -38 11 -74 13 -36 3 -73 8 -82 13 -29 12 -22 -23 11 -56 28 -28 33 -29 121 -29 88 0 93 1 121 29 33 33 37 67 14 111 -19 36 -46 44 -128 38 -44 -4 -69 -1 -84 10 -30 19 -29 24 7 46 21 12 35 15 43 8 7 -6 41 -12 77 -14 36 -2 73 -8 83 -12 28 -13 21 22 -12 55 -28 28 -33 29 -121 29 -88 0 -93 -1 -121 -29z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendsprint);
export default __webpack_public_path__ + "static/media/sendsprint.146edb59400d50c9cf1fa4da94febb9d.svg";
export { ForwardRef as ReactComponent };